export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const UPDATE_TRANSACTION_VALUE = "UPDATE_TRANSACTION_VALUES";
export const SET_TRANSACTION_LOADING = "SET_TRANSACTION_LOADING";
export const CREATE_TRANSACTION_ERROR = "CREATE_TRANSACTION_ERROR";
export const CREATE_BENEFICIARY = "CREATE_BENEFICIARY";
export const GET_BENEFICIARY = "GET_BENEFICIARY";
export const GET_TRANSACTION_ERROR = "GET_TRANSACTION_ERROR";
export const COMPLETE_TRANSACTION = "COMPLETE_TRANSACTION";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
export const VERIFY_BANK = "VERIFY_BANK";
export const VERIFY_BANK_ERROR = "VERIFY_BANK_ERROR";
export const GET_BANKS = "GET_BANKS";
export const GET_BANKS_ERROR = "GET_BANKS_ERROR";
export const SET_BANKS_LOADING = "SET_BANKS_LOADING";
